export var Role;
(function (Role) {
    Role["Admin"] = "Admin";
    Role["Sales"] = "Sales";
    Role["Customer"] = "Customer";
    Role["Candidate"] = "Candidate";
    Role["Researcher"] = "Researcher";
    Role["CustomerPowerUser"] = "CustomerPowerUser";
})(Role || (Role = {}));
;
